var map = {
	"./avalanche/launchpad/ccash.jpg": "7b1d",
	"./avalanche/launchpad/dnt.jpg": "f9f8",
	"./avalanche/launchpad/ethermoon.jpg": "3654",
	"./avalanche/launchpad/icade.jpg": "a125",
	"./avalanche/launchpad/lgx.jpg": "e8f6",
	"./avalanche/launchpad/pgk.jpg": "a21c",
	"./avalanche/launchpad/pinknode.jpg": "4992",
	"./avalanche/launchpad/senate.jpg": "dfb5",
	"./avalanche/launchpad/sidus.jpg": "2fb5",
	"./avalanche/launchpad/sleep.jpg": "c6ee",
	"./avalanche/launchpad/taur.jpg": "fb05",
	"./avalanche/launchpad/warp.jpg": "f5be",
	"./binance/launchpad/ccash.jpg": "0195",
	"./binance/launchpad/dnt.jpg": "93c8",
	"./binance/launchpad/ethermoon.jpg": "75f9",
	"./binance/launchpad/icade.jpg": "319b",
	"./binance/launchpad/lgx.jpg": "600c",
	"./binance/launchpad/pgk.jpg": "90eb",
	"./binance/launchpad/pinknode.jpg": "13d5d",
	"./binance/launchpad/senate.jpg": "101e",
	"./binance/launchpad/sidus.jpg": "9af3",
	"./binance/launchpad/sleep.jpg": "d61f",
	"./binance/launchpad/taur.jpg": "366b",
	"./binance/launchpad/walkn.jpg": "5f24",
	"./binance/launchpad/warp.jpg": "f93c",
	"./ethereum/launchpad/ccash.jpg": "ea1b",
	"./ethereum/launchpad/dnt.jpg": "0a10",
	"./ethereum/launchpad/ethermoon.jpg": "e804",
	"./ethereum/launchpad/icade.jpg": "5760",
	"./ethereum/launchpad/launchpad-banner-bg.jpg": "8ee4",
	"./ethereum/launchpad/lgx.jpg": "a038",
	"./ethereum/launchpad/pgk.jpg": "6cf8",
	"./ethereum/launchpad/pinknode.jpg": "0f1a",
	"./ethereum/launchpad/senate.jpg": "ea80",
	"./ethereum/launchpad/sidus.jpg": "3fa6",
	"./ethereum/launchpad/sleep.jpg": "e4c2",
	"./ethereum/launchpad/taur.jpg": "73de",
	"./ethereum/launchpad/walkn.jpg": "73df",
	"./ethereum/launchpad/warp.jpg": "c263"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0f31";